import React, { useState } from 'react';
import { IllustrationName } from './illustrationLibrary';
import { classNames } from '../../utils/style';
import { retrocompatibility } from './retrocompatibility';

interface IllustrationProps {
  name: IllustrationName;
  className?: string;
  alt?: string;
  disablePadding?: boolean;
  size?: 'big' | 'small';
  loading?: 'lazy' | 'eager';
  style?: React.CSSProperties;
}

export const Illustration: React.FC<IllustrationProps> = ({
  name,
  className,
  alt = '',
  loading,
  style,
}) => {
  const [error, setError] = useState(false);

  const handleError = () => {
    setError(true);
  };

  return (
    <img
      src={`/icons/illustrations/${retrocompatibility(name)}.svg`}
      alt={alt}
      onError={handleError}
      loading={loading}
      className={classNames(className)}
      width={40}
      height={40}
      style={style}
    />
  );
};
